import React from 'react';
import { Trans } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserLink from '@wix/da-shared-react/pkg/User/Link';

import s from './Commentable.scss';

export interface Props {
  profile: PapiUser;
}

export const Profile: React.FC<Props> = ({ profile }) => (
  <h1 className={s['text']}>
    <Trans i18nKey="commentable.header.profile">
      Comment on <UserLink className={s['link']} user={profile} />
      &apos;s profile
    </Trans>
  </h1>
);
Profile.displayName = 'Profile';

export default Profile;
